import type { ChartConfig } from "@/components/ui/chart";
import { MEMBER_COLOR_PALETTE, memberColor } from "@/lib/member-colors";

/** @deprecated Use MEMBER_COLOR_PALETTE from @/lib/member-colors */
export const TASK_MEMBER_AREA_PALETTE = MEMBER_COLOR_PALETTE;

export function memberSeriesKey(memberId: string): string {
  return `m_${memberId.replace(/-/g, "")}`;
}

export function buildMemberAreaChartConfig(
  members: { id: string; name: string }[],
): ChartConfig {
  const config: ChartConfig = {};
  members.forEach((member, index) => {
    const palette = TASK_MEMBER_AREA_PALETTE[index % TASK_MEMBER_AREA_PALETTE.length];
    config[memberSeriesKey(member.id)] = {
      label: member.name,
      theme: { light: palette.light, dark: palette.dark },
    };
  });
  return config;
}

export function memberAreaColor(
  memberIndex: number,
  mode: "light" | "dark" = "dark",
): string {
  return memberColor(memberIndex, mode);
}
